import { render, staticRenderFns } from "./loading-bar.vue?vue&type=template&id=4212dabc&scoped=true&"
import script from "./loading-bar.vue?vue&type=script&lang=js&"
export * from "./loading-bar.vue?vue&type=script&lang=js&"
import style0 from "./loading-bar.vue?vue&type=style&index=0&id=4212dabc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4212dabc",
  null
  
)

export default component.exports